$('.modal__details--skip').on('click', function (e) {
	e.preventDefault();
	$('.modal__details').removeClass('open');
	$('body').removeClass('modal-open');
});